import axios from 'axios';

export default {
    getAllProjectsForUser(keys) {
        return axios
            .post('http://wichteln-api.lifemap.rocks/project/find', { keys: keys })
            .then(response => {
                return response.data;
            });
    },
    getProjectById(id) {
        return axios
            .get('http://wichteln-api.lifemap.rocks/project/' + id)
            .then(response => {
                return response.data;
            });
    },
    createProject(project) {
        return axios
            .post('http://wichteln-api.lifemap.rocks/project', project)
            .then(response => {
                return response.data;
            })
    },
    updateProject(project) {
        return axios
            .put('http://wichteln-api.lifemap.rocks/project/' + project.id, project)
            .then(response => {
                return response.data;
            })
    },
    finishProject(project) {
        return axios
            .get('http://wichteln-api.lifemap.rocks/project/' + project.id + '/finishProject')
            .then(response => {
                return response.data;
            }).catch(error => {
                return Promise.reject(error.response.data);
            });
    },
    resendMails(project) {
        return axios
            .get('http://wichteln-api.lifemap.rocks/project/' + project.id + '/resendMails')
            .then(response => {
                return response.data;
            }).catch(error => {
                return Promise.reject(error.response.data);
            });
    },
    inviteUser(email, project) {
        return axios
            .post('http://wichteln-api.lifemap.rocks/project/' + project.id + '/inviteUser', { email: email })
            .then(response => {
                return response.data;
            }).catch(error => {
                return Promise.reject(error.response.data);
            });
    },
    addUserToProject(user, project) {
        return axios
            .post('http://wichteln-api.lifemap.rocks/project/' + project.id + '/addUser', { user: user })
            .then(response => {
                return response.data;
            }).catch(error => {
                return Promise.reject(error.response.data);
            });
    },
    removeUserFromProject(user, project) {
        return axios
            .post('http://wichteln-api.lifemap.rocks/project/' + project.id + '/removeUser', { user: user })
            .then(response => {
                return response.data;
            })
    },
    getJoinLink(project) {
        return 'http://localhost/project/' + project.id + '/join';
    },
    addProjectToLocalStorage(projectKey, role) {
        var currentProjects = localStorage.getItem('projects');

        if (currentProjects) {
            currentProjects = JSON.parse(currentProjects);
            currentProjects.push({ projectKey: projectKey, role: role });
            localStorage.setItem('projects', JSON.stringify(currentProjects));
        } else {
            currentProjects = [];
            currentProjects.push({ projectKey: projectKey, role: role });
            localStorage.setItem('projects', JSON.stringify(currentProjects));
        }
    },
    getProjectsFromLocalStorage() {
        return JSON.parse(localStorage.getItem('projects'));
    },
    getProjectFromLocalStorage(key) {
        let allProjects = JSON.parse(localStorage.getItem('projects'));
        let filtered = allProjects.filter(entry => {
            return entry.projectKey === key
        });
        if (filtered.length > 0) {
            return filtered;
        } else return [];
    }
}
